var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceSubsidence({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.288 2 2.063 3.94.341-1.232c.126-.456.678-.55 1.654-.279.91.252 1.355.59 1.334 1.012l-.012.091-1.16 4.187.712 1.167c.374.48.48 1.015.316 1.607-.148.533-.372.87-.673 1.011l-.103.04-1.218-.338L15.77 16H8.149l-3.373-3.092c.095-.49.223-1.056.394-1.708l.296-1.062-.974-.27C4.1 9.76 3.869 9.252 4.08 8.49c.116-.42.32-.724.612-.913l.13-.073L13.288 2Zm-1.141 10.395-2.208-.611a1 1 0 0 0-1.193.586L8.62 13c-.1.495.185.986.668 1.133.93.283 2.345.676 2.702.565a.998.998 0 0 0 .716-.6l.037-.11.1-.362a1 1 0 0 0-.696-1.23Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.9 13.461-.29-.223a1 1 0 0 0-1.61.793V21a1 1 0 0 0 1 1h10.215l-9.316-8.539ZM14.694 22H21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H9.24l5.454 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceSubsidence);
export default __webpack_public_path__ + "static/media/france_subsidence.160cb43edf421bee6c085cefab21fb3f.svg";
export { ForwardRef as ReactComponent };